import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import './styles/index.css';
import reportWebVitals from './utils/reportWebVitals';
import { createRouter } from './App';
import { msalInstance } from './lib/msal';
import { AuthenticationBootstrap } from './components/AuthenticationBootstrap';

initializeIcons();

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element #root was not found.');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
    <MsalProvider instance={msalInstance}>
        <AuthenticationBootstrap
            createAuthenticatedContent={() => <RouterProvider router={createRouter()} />}
        />
    </MsalProvider>,
);

reportWebVitals();
